"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = _interopRequireDefault(require("./amb.Properties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenManagementExtension = function TokenManagementExtension() {
  var LOGGER = new _amb.default('amb.TokenManagementExtension');
  var META_SUBSCRIBE = '/meta/subscribe';
  var META_UNSUBSCRIBE = '/meta/unsubscribe';
  var META_HANDSHAKE = '/meta/handshake';
  var tokenCount = _amb2.default.subscribeCommandsFlow.maxInflight;
  var tokenEventListeners = [];

  this.updateTokenCount = function (count) {
    tokenCount = count;
  };

  this.refillTokens = function () {
    tokenCount = _amb2.default.subscribeCommandsFlow.maxInflight;
    notifyOnAvailabilityOfToken();
    LOGGER.debug("refillTokens -- tokenCount : " + tokenCount);
  };

  function isMetaSubUnsubChannel(message) {
    return message.channel == META_SUBSCRIBE || message.channel == META_UNSUBSCRIBE;
  }

  function isReceivedByGlideAndMetaSubUnsubChannel(message) {
    if (!message.ext) return false;
    var receivedByGlide = message.ext['received_by_glide'];
    if (!receivedByGlide) return false;
    return receivedByGlide && isMetaSubUnsubChannel(receivedByGlide);
  }

  function isMetaHandshake(message) {
    return message.channel === META_HANDSHAKE;
  }

  this.outgoing = function (message) {
    if (isMetaHandshake(message)) {
      if (!message.ext) message.ext = {};
      message.ext.supportsSubscribeCommandFlow = true;
    }

    if (!_amb2.default.subscribeCommandsFlow.enable) return message;
    if (isMetaSubUnsubChannel(message) && tokenCount > 0) tokenCount--;
    return message;
  };

  this.incoming = function (message) {
    if (!_amb2.default.subscribeCommandsFlow.enable) return message;

    if (isMetaSubUnsubChannel(message)) {
      if (tokenCount < _amb2.default.subscribeCommandsFlow.maxInflight) tokenCount++;
      notifyOnAvailabilityOfToken();
    } else if (isReceivedByGlideAndMetaSubUnsubChannel(message)) {
      message = null; // Make cometd not to call back any listeners based on the message id.
    }

    return message;
  };

  this.getTokenCount = function () {
    return tokenCount;
  };

  this.addTokenAvailabilityListener = function (tokenEventListener) {
    if (!tokenEventListener) return;
    LOGGER.debug("addTokenAvailabilityListener - tokenEventListener : " + tokenEventListener);
    tokenEventListeners.push(tokenEventListener);
  };

  this.removeTokenAvailabilityListener = function (tokenEventListener) {
    if (!tokenEventListener) return;
    LOGGER.debug("removeTokenAvailabilityListener - tokenEventListener : " + tokenEventListener);
    var removeIndex = tokenEventListeners.findIndex(function (listener) {
      return tokenEventListener === listener;
    });

    if (removeIndex !== -1) {
      LOGGER.debug("removeTokenAvailabilityListener - removing listener at index : " + removeIndex);
      tokenEventListeners.splice(removeIndex, 1);
    }
  };

  function notifyOnAvailabilityOfToken() {
    LOGGER.debug("notifyOnAvailabilityOfToken - current tokenCount: " + tokenCount);

    try {
      tokenEventListeners.forEach(function (listener) {
        listener();
      });
    } catch (error) {
      LOGGER.addErrorMessage("notifyOnAvailabilityOfToken - failed to call tokenEventListeners. Error Details : " + error);
    }
  }
};

var _default = TokenManagementExtension;
exports.default = _default;